import React from 'react';
import Icon from '@/components/ui/Icon';

interface CoTeacherBadgeProps {
  stafferId: number,
  teacherDisplayName: string,
}

export const CO_TEACHER_COLORS = [
  { bg: '#EEEEF9', main: '#5258C6' },
  { bg: '#F5F0E5', main: '#926400' },
  { bg: '#E5F2EB', main: '#007E34' },
  { bg: '#F7ECEB', main: '#B44539' },
  { bg: '#FAE5F0', main: '#C9006B' },
  { bg: '#E5F2F4', main: '#00778F' },
  { bg: '#FDEAE9', main: '#D32215' },
  { bg: '#FBF1E8', main: '#B15500' },
  { bg: '#EDEFF1', main: '#475D76' },
  { bg: '#EEEAF4', main: '#522E91' },
  { bg: '#E5EFEC', main: '#005C42' },
  { bg: '#F0F5D2', main: '#63720E' },
  { bg: '#E5EEF8', main: '#0051BA' },
  { bg: '#F9E9EB', main: '#C22034' },
  { bg: '#E5F6FC', main: '#0077A4' },
];

const CoTeacherBadge = ({ stafferId, teacherDisplayName }: CoTeacherBadgeProps) => {
  const coTeacherColor = CO_TEACHER_COLORS[stafferId % CO_TEACHER_COLORS.length];

  return (
    <div
      className="tw-flex tw-items-center tw-rounded-full tw-w-fit tw-px-1.5 tw-py-1 tw-gap-1"
      style={{ backgroundColor: coTeacherColor.bg, color: coTeacherColor.main }}
    >
      <Icon fill={coTeacherColor.main} icon="CoTeacher" />
      {teacherDisplayName}
    </div>
  );
};

export default CoTeacherBadge;
